import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * Above a journal whose server says a newer event was written than the first
 * row shown (#1397): the rows read so far are consistent, but not the latest,
 * and the reader is told so instead of taking them for the whole story.
 */
export function JournalNewerEventsNotice({ onRefresh }: { onRefresh: () => void }) {
  const { t } = useTranslation(['settings', 'common']);
  return (
    <div className="flex items-center justify-between gap-2" role="status">
      <p className="text-xs text-fg-muted">{t('consent.journalNewerEvents')}</p>
      <Button variant="ghost" size="sm" onClick={onRefresh}>
        {t('common:common.refresh', 'Refresh')}
      </Button>
    </div>
  );
}
